var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopIconGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0yowfewnoa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 14995",
    transform: "translate(1543 3435)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h25v25H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 50",
    transform: "translate(-1543 -3435)",
    style: {
      clipPath: "url(#0yowfewnoa)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 217"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1",
    d: "M9.167 0 0 9.167l9.167 9.167",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#999",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    transform: "rotate(90 -938.167 2502.5)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 22",
    d: "M0 17.417V0",
    transform: "translate(1555.333 3441.584)",
    style: {
      fill: "none",
      stroke: "#999",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 9",
    transform: "translate(1546.333 3437)",
    style: {
      fill: "none",
      stroke: "#999",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0h18"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopIconGray);
export default __webpack_public_path__ + "static/media/top_icon_gray.1aef1d7569694fa9ac5eb7e63704ddef.svg";
export { ForwardRef as ReactComponent };